import { useSettingsStore, useUserStore } from '~/stores';

interface GTagComposable {
    trackEvent: (
        action: string,
        metadata?: Record<string, string | boolean | null | undefined | number | bigint>,
        firstTimeNamespace?: string,
    ) => void;
}

export function useGTag(): GTagComposable {
    try {
        const settingsStore = useSettingsStore();
        const userStore = useUserStore();

        const isFirstTime: Set<string> = new Set(JSON.parse(localStorage.getItem('gtag_first_time') ?? '[]'));

        const trackEvent = (
            action: string,
            metadata?: Record<string, string | boolean | null | undefined | number | bigint>,
            firstTimeNamespace?: string,
        ) => {
            try {
                if (!__DEBUG__ && (!('gtag' in window) || !(typeof window.gtag === 'function'))) return;

                if (!settingsStore.isPhysgun) return;

                const firstTimeKey = firstTimeNamespace ? `${action}:${firstTimeNamespace}` : action;

                metadata ??= {};
                metadata.first_time = !isFirstTime.has(firstTimeKey);

                if (!metadata.first_time) {
                    isFirstTime.add(firstTimeKey);
                    localStorage.setItem('gtag_first_time', JSON.stringify(Array.from(isFirstTime)));
                }

                metadata.user_id = userStore.data?.id ?? null;
                metadata.user_whcms_id = (userStore.data?.externalId === -1 ? null : userStore.data?.externalId) ?? null;

                metadata.fqdn = window.location.hostname;

                if (__DEBUG__) {
                    console.debug('gtag', action, metadata);
                }

                if ('gtag' in window && typeof window.gtag === 'function') {
                    window.gtag('event', action, metadata);
                }
            } catch (err) {
                console.error('Failed to track gtag event:', err);
            }
        };

        return { trackEvent };
    } catch (err) {
        console.error('Failed to initialize gtag:', err);

        return { trackEvent: (..._args: any[]) => {} };
    }
}
